import { roundedRect } from '@bn-games/render-helpers';
import type { ChainRegion } from './BoardRenderer.js';
import type { RenderPalette } from './palette.js';

export interface ViewportControlsButton {
  readonly x: number;
  readonly y: number;
  readonly w: number;
  readonly h: number;
}

const BTN_SIZE = 36;
const BTN_MARGIN = 12;
const BTN_RADIUS = 8;

/** Square fit-to-view button anchored to the top-right of the chain region. */
export function layoutResetButton(region: ChainRegion): ViewportControlsButton {
  return {
    x: region.x + region.width - BTN_SIZE - BTN_MARGIN,
    y: region.y + BTN_MARGIN,
    w: BTN_SIZE,
    h: BTN_SIZE,
  };
}

export function drawResetButton(
  ctx: CanvasRenderingContext2D,
  btn: ViewportControlsButton,
  palette: RenderPalette,
  active: boolean,
): void {
  ctx.save();
  ctx.shadowColor = 'rgba(0, 0, 0, 0.35)';
  ctx.shadowBlur = 6;
  ctx.shadowOffsetY = 2;
  roundedRect(ctx, btn.x, btn.y, btn.w, btn.h, BTN_RADIUS);
  ctx.fillStyle = active ? palette.validArmGlow : palette.bannerBg;
  ctx.fill();
  ctx.shadowColor = 'transparent';
  ctx.shadowBlur = 0;
  ctx.shadowOffsetY = 0;
  ctx.strokeStyle = palette.bannerBorder;
  ctx.lineWidth = 1.5;
  roundedRect(ctx, btn.x + 0.5, btn.y + 0.5, btn.w - 1, btn.h - 1, BTN_RADIUS);
  ctx.stroke();

  // "Fit" icon: small rectangle with corner brackets.
  ctx.strokeStyle = palette.bannerTextColor;
  ctx.lineWidth = 2;
  const cx = btn.x + btn.w / 2;
  const cy = btn.y + btn.h / 2;
  const r = 9;
  const arm = 4;
  ctx.beginPath();
  // top-left bracket
  ctx.moveTo(cx - r, cy - r + arm);
  ctx.lineTo(cx - r, cy - r);
  ctx.lineTo(cx - r + arm, cy - r);
  // top-right
  ctx.moveTo(cx + r - arm, cy - r);
  ctx.lineTo(cx + r, cy - r);
  ctx.lineTo(cx + r, cy - r + arm);
  // bottom-right
  ctx.moveTo(cx + r, cy + r - arm);
  ctx.lineTo(cx + r, cy + r);
  ctx.lineTo(cx + r - arm, cy + r);
  // bottom-left
  ctx.moveTo(cx - r + arm, cy + r);
  ctx.lineTo(cx - r, cy + r);
  ctx.lineTo(cx - r, cy + r - arm);
  ctx.stroke();
  ctx.restore();
}

export function hitTestResetButton(
  btn: ViewportControlsButton,
  x: number,
  y: number,
): boolean {
  return x >= btn.x && x <= btn.x + btn.w && y >= btn.y && y <= btn.y + btn.h;
}
